import { post } from './Api';

const endpoint = 'inventory/packaging-slips';

export const read = async (data) => await post(`${endpoint}/read`, data);
